

export interface NextId {
    id: number;
    serverTag: string;
}
